import { render, staticRenderFns } from "./MitigationsThreatsTable.vue?vue&type=template&id=254b7f85&"
import script from "./MitigationsThreatsTable.vue?vue&type=script&lang=js&"
export * from "./MitigationsThreatsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports